export interface QtyStepperProps {
  qty: number;
  max: number;
  onIncrement: () => void;
  onDecrement: () => void;
  disabled?: boolean;
  /** Used to build accessible names, e.g. the product name. */
  label: string;
}

/** A -/+ quantity stepper. Decrementing below the caller's minimum is the caller's decision (e.g. show a confirm dialog). */
export function QtyStepper({ qty, max, onIncrement, onDecrement, disabled, label }: QtyStepperProps) {
  return (
    <div className="inline-flex items-center gap-2" role="group" aria-label={`Quantity for ${label}`}>
      <button
        type="button"
        onClick={onDecrement}
        disabled={disabled}
        aria-label={`Decrease quantity of ${label}`}
        className="h-12 w-12 rounded-lg bg-aqua text-teal-dark font-heading font-bold text-xl flex items-center justify-center disabled:opacity-40"
      >
        &minus;
      </button>
      <span className="min-w-8 text-center font-heading font-semibold text-lg" aria-live="polite">
        {qty}
      </span>
      <button
        type="button"
        onClick={onIncrement}
        disabled={disabled || qty >= max}
        aria-label={`Increase quantity of ${label}`}
        className="h-12 w-12 rounded-lg bg-aqua text-teal-dark font-heading font-bold text-xl flex items-center justify-center disabled:opacity-40"
      >
        +
      </button>
    </div>
  );
}
